import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  quote: string;
  product?: string;
}
export function TestimonialCard({
  initials,
  name,
  location,
  quote,
  product
}: TestimonialProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="bg-brand-black border border-gray-800 rounded-2xl p-6 md:p-8 flex flex-col h-full hover:border-brand-green/30 transition-colors" data-id="element-296">
      <div className="flex items-center gap-4 mb-6" data-id="element-297">
        <div className="w-12 h-12 rounded-full bg-brand-dark border border-brand-green/30 flex items-center justify-center text-brand-light font-bold text-lg" data-id="element-298">
          {initials}
        </div>
        <div data-id="element-299">
          <div className="font-bold text-white" data-id="element-300">{name}</div>
          <div className="text-sm text-gray-400" data-id="element-301">{location}</div>
        </div>
      </div>

      <div className="flex gap-1 mb-4" data-id="element-302">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-brand-gold fill-brand-gold" data-id="element-303" />)}
      </div>

      <p className="text-gray-300 italic flex-grow" data-id="element-304">"{quote}"</p>

      {product && <div className="mt-6 pt-4 border-t border-gray-800 text-xs text-brand-light font-medium" data-id="element-305">
          Compró: {product}
        </div>}
    </motion.div>;
}
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Tucumán',
    quote: 'Años sin poder sentarme tranquila en una mesa. Al día 21 fui al cumpleaños de mi nieta y no pensé en mi panza ni una vez.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Buenos Aires',
    quote: 'No era la comida. Era mi sistema nervioso en modo alarma. Ahora sé cómo apagarlo antes de que empiece.'
  }, {
    initials: 'RM',
    name: 'Roxana M.',
    location: 'Córdoba',
    quote: 'El primer sistema que me explica por qué me duele y me da una herramienta para frenarlo en el momento.'
  }];
  return <section className="py-20 bg-brand-dark" data-id="element-306">
      <div className="container mx-auto px-4" data-id="element-307">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-308">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-309" />)}
        </div>
      </div>
    </section>;
}